angular.
module("dx.webapp.jobs").
controller("DxJobsListController", function JobsListController(
	$interval,
	$scope,
	$location,

	DX_URLS,
	dxApi,
	dxSession,
	RoleTypeEnum,
	DX_JOB_SORT_PREDICATE,
	DxJob,
	DX_JOB_STATUS,
	DX_JOB_TYPE,
	DX_JOB_ORIGIN,
	DX_KEY_CODES
) {
	"use strict";

	var self = this;

	self.RoleTypeEnum = RoleTypeEnum;
	self.DX_JOB_SORT_PREDICATE = DX_JOB_SORT_PREDICATE;

	self.role = dxSession.getRole();
	self.loading = true;
	self.error = null;
	self.jobs = [];
	self.pageToken = null;

	var defaultQuery = Object.freeze({
		jobID: null,
		userID: null,
		type: null,
		status: null,
		created: new Date(0),
		organizationID: null,
		origin: null,
	});
	self.query = angular.copy(defaultQuery);

	self.minDate = new Date("2013-01-01");
	self.jobTypes = Object.values(DX_JOB_TYPE);
	self.jobStatuses = {};
	self.jobStatuses[DX_JOB_STATUS.CREATED] = "Jobs.Status.Created";
	self.jobStatuses[DX_JOB_STATUS.RUNNING] = "Jobs.Status.Running";
	self.jobStatuses[DX_JOB_STATUS.DONE] = "Jobs.Status.Done";
	self.jobOrigins = Object.values(DX_JOB_ORIGIN);

	var defaultOrder = Object.freeze({
		predicate: DX_JOB_SORT_PREDICATE.DATE,
		reverse: true,
	});
	self.orderJobsBy = angular.copy(defaultOrder);

	var refreshInterval = null;

	function onJobLoadSuccess(response) {
		self.loading = false;
		self.pageToken = response.data.pageToken;

		response.data.jobs.map(function createJob(data) {
			self.jobs.push(new DxJob(data));
		});

		if (!refreshInterval && updateJobsRunning()) {
			refreshInterval = $interval(updateJobsRunning, 1500);
		}
	}

	function onJobLoadFail() {
		self.loading = false;
		self.error = "AccountManagerImports.Error.SomethingWentWrong";
	}

	function updateJobsRunning() {
		var recheckNeeded = false;
		for (var i = 0; i < self.jobs.length; i++) {
			// Don't poll GDPR delete jobs since they have a 32-hour delay
			if (self.jobs[i].status !== "done" &&
				self.jobs[i].type !== DX_JOB_TYPE.GDPR_DELETE_USER &&
				self.jobs[i].type !== DX_JOB_TYPE.GDPR_DELETE_STUDENT) {
				dxApi.v1.jobs.get(self.jobs[i].id).then(updateJob);
				recheckNeeded = true;
			}
		}

		if (!recheckNeeded && refreshInterval) {
			$interval.cancel(refreshInterval);
			refreshInterval = null;
		}
		return recheckNeeded;
	}

	function updateJob(response) {
		var index = self.jobs.findIndex(function compareId(job) {
			return job.id === response.data.id;
		});
		self.jobs[index] = new DxJob(response.data);
	}

	function getOrderByParam() {
		return (self.orderJobsBy.reverse ? "-" : "") + self.orderJobsBy.predicate;
	}

	function fetchJobs() {
		self.loading = true;

		var params = angular.extend({}, self.query, {
			pageToken: self.pageToken,
			orderBy: getOrderByParam(),
			created: self.query.created.valueOf() === 0 ? null : self.query.created.toUTCString(),
		});
		dxApi.v1.jobs.list(params).then(onJobLoadSuccess, onJobLoadFail);
	}

	$scope.$on("$destroy", function onScopeDestroy() {
		if (refreshInterval) {
			$interval.cancel(refreshInterval);
			refreshInterval = null;
		}
	});

	fetchJobs();

	self.showJob = function showJob(id) {
		$location.path(DX_URLS.get("jobsView", {jobId: id}));
	};

	self.setJobOrder = function setJobOrder(predicate) {
		if (self.orderJobsBy.predicate === predicate) {
			self.orderJobsBy.reverse = !self.orderJobsBy.reverse;
		} else {
			self.orderJobsBy.predicate = predicate;
			self.orderJobsBy.reverse = false;
		}
		self.pageToken = null;
		self.jobs = [];
		fetchJobs();
	};

	self.navigateToImportStudents = function navigateToImportStudents() {
		$location.path(DX_URLS.get("importStudents"));
	};

	self.onTableRowKeyDown = function onTableRowKeyDown(event, id) {
		if (event.keyCode !== DX_KEY_CODES.enter && event.keyCode !== DX_KEY_CODES.space) {
			return;
		}
		event.preventDefault();

		self.showJob(id);
	};

	self.nextPage = function nextPage() {
		fetchJobs();
	};

	self.jobSearch = function jobSearch() {
		self.pageToken = null;
		self.jobs = [];
		self.orderJobsBy = angular.copy(defaultOrder);
		fetchJobs();
	};

	self.clearJobSearch = function clearJobSearch() {
		self.query = angular.copy(defaultQuery);
		self.error = null;
		self.jobSearch();
	};

	self.validateCreatedDate = function validateCreatedDate(error) {
		if (error === "invaliddate") {
			self.error = "StartExamPopup.StartDateInvalid";
		} else if (error === "nodate") {
			// the date input is empty
			self.query.created = new Date(0);
			self.error = null;
		} else {
			self.error = null;
		}
	};
});
